<span id="status-container">
  <div class="toggle-wrapper">
    <mat-slide-toggle
      id="alert-status-toggle"
      [checked]="isEnabled"
      (change)="onStatusChange()"
      color="primary"
      class="toggle-track"
      labelPosition="before"
      >{{ isEnabled ? 'Enabled' : 'Disabled' }}
    </mat-slide-toggle>
  </div>
</span>
